import * as React from "react";
import Select, { SingleValue, FilterOptionOption, InputActionMeta } from "react-select";
import { createDropdownStyles } from './DropdownSearchableClearableStyles';

export interface OptionType {
    value: string;
    label: string;
}

interface Props {
    placeholder?: string;
    name?: string;
    options: OptionType[];
    value?: OptionType | null;
    inputValue?: string;
    setInputValue?: (value: string) => void;
    onChange?: (selectedOption: SingleValue<OptionType>) => void;
    filterMinLength?: number;
    className?: string;
    minWidth?: string;
    maxWidth?: string;
    isDisabled?: boolean;
    width?: string;
    ariaLabel?: string;
}

export class DropdownSearchableClearable extends React.Component<Props> {
    static defaultProps = {
        filterMinLength: 0,
    };

    handleInputChange = (value: string, actionMeta: InputActionMeta) => {
        if (actionMeta.action === 'input-change') {
            this.props.setInputValue?.(value);
        }
    }

    handleChange = (selectedOption: SingleValue<OptionType>) => {
        this.props.onChange?.(selectedOption);
    }

    filterOption = (option: FilterOptionOption<OptionType>, input: string) => {
        const { filterMinLength = 0 } = this.props;
        return (
            input.length >= filterMinLength &&
            option.label.toLowerCase().includes(input.toLowerCase())
        );
    };

    private cachedStyles: ReturnType<typeof createDropdownStyles> | null = null;
    private cachedStyleProps: string = '';

    getStyles() {
        const { minWidth, maxWidth, width } = this.props;
        const key = `${minWidth}-${maxWidth}-${width}`;
        if (this.cachedStyleProps !== key) {
            this.cachedStyles = createDropdownStyles({ minWidth, maxWidth, width });
            this.cachedStyleProps = key;
        }
        return this.cachedStyles!;
    }

    render() {
        const { placeholder, name, options, value, inputValue, filterMinLength = 0, className } = this.props;

        const customStyles = this.getStyles();

        return (
            <Select
                placeholder={placeholder}
                isClearable
                isSearchable
                name={name}
                options={options}
                value={value}
                inputValue={inputValue}
                onInputChange={this.handleInputChange}
                onChange={this.handleChange}
                filterOption={this.filterOption}
                noOptionsMessage={() => inputValue && inputValue.length < filterMinLength
                    ? `Please enter ${filterMinLength} or more characters`
                    : 'No options'
                }
                className={className}
                classNamePrefix="select"
                styles={customStyles}
                isDisabled={this.props.isDisabled}
                aria-label={this.props.ariaLabel || placeholder || name}
            />
        );
    }
}

export default DropdownSearchableClearable;
